module.exports = __webpack_public_path__ + "img/gongan-beian.d0289dc0.png";